import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " You have been successfully logged out. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_message = _resolveComponent("b-message")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_b_message, { type: "is-success" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("p", null, [
          _createVNode(_component_router_link, { to: { name: 'Home' } }, {
            default: _withCtx(() => [
              _createTextVNode(" Log in again ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}